<template>
    <v-container fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12 sm10 md6>
                <v-card class="my-1 elevation-12">
                    <v-toolbar dark color="#a6b0a5">
                        <v-toolbar-title class="headline text-shadow-black">Login Form</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text class="subtitle-1">
                        <v-form ref="form" v-model="valid">
                            <v-text-field
                                prepend-icon="mdi-email"
                                name="email"
                                label="Email"
                                type="email"
                                v-model="email"
                                :rules="emailRules"
                                required
                            >
                            </v-text-field>
                            <v-text-field
                                prepend-icon="mdi-lock"
                                name="password"
                                label="Password"
                                type="password"
                                v-model="password"
                                :rules="passwordRules"
                                required
                            >
                            </v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="#E3C196"
                            class="black--text"
                            :disabled="!valid"
                            @click="submit"
                            >Login</v-btn
                        >
                    </v-card-actions>
                    <v-card-text class="subtitle-1">
                        <p class="text-md-right">You don't have an account? <br class="hidden-md-and-up">You can <router-link to="/sign-up">create one</router-link>.</p>
                    </v-card-text>
                </v-card>
                
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: 'LogIn',
    data() {
        return {
            valid: false,
            email: '',
            password: '',
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+/.test(v) || 'E-mail must be valid'
            ],
            passwordRules: [
                v => !!v || 'Password is required',
                v =>
                    v.length >= 6 ||
                    'Password must be greater than 6 characters'
            ]
        };
    },
    methods: {
        submit() {
            if (this.$refs.form.validate()) {
                this.$store.dispatch('userLogin', {
                    email: this.email,
                    password: this.password
                });
            }
        }
    }
};
</script>